var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2",staticStyle:{"font-size":"18px"},attrs:{"data-toggle":"tooltip","data-placement":_vm.placement,"title":_vm.text}},[_c('i',{staticClass:"fa fa-question-circle"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f23df04","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TooltipQuestion.vue
// module id = L4c/
// module chunks = 1